<div class="spinner-wrapper" [style.z-index]="zIndex">
  <div class="ui active inverted dimmer" [ngClass]="{ transparent: isTransparent }">
    <div class="loader-wrapper">
      <div class="ui loader"></div>
      <span *ngIf="loadingText" class="loading-text">{{ loadingText }}</span>
    </div>
  </div>
</div>
